import React, {Component} from 'react';
import couterpart from 'counterpart';
import {ToastsContainer, ToastsStore} from 'react-toasts';

import DesignImageList from './DesignImageList';

import WorkOrderDataService from '../services/WorkOrderDataService';
import AuthenticationService from '../services/AuthenticationService';
import '../css/style.css';
import { ICON_COLOR } from '../icon';
import {FaUpload} from 'react-icons/fa';
import {MdFileUpload} from 'react-icons/md';

class ImageUploader extends Component{
    state = {
        count: 0,
        file: null
    }

    handleFile(e){
        let file = e.target.files;
        
        this.setState({file}, ()=>{
            if (file != null && file.length > 0){
                var selectedFiles = "";
                var fileSep = "";
                for(var i=0; i<file.length;i++){
                    selectedFiles += fileSep + file[i].name;
                    fileSep = ", ";
                }
                
                this.setState({
                    selectedFilenames: selectedFiles
                });
            }
        }); 
    }

    handleUpload(e){
        let files = this.state.file;
        if ((files === null) || (files === undefined) || (files.length < 1)){
            ToastsStore.error(couterpart.translate("msg_upload_validate_file"));
            return;
        }
        
        WorkOrderDataService.uploadImages(files).then(data => {
            ToastsStore.info(couterpart.translate("msg_saved_info"));
            let count = this.state.count + 1;
            this.setState({ count: count });
        });
    }

    render(){
        if (AuthenticationService.isAdmin() || AuthenticationService.isService()){
            return (
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12">
                                <h4 style={{ marginTop: "30px"}}>{ couterpart.translate("default_image_upload") }</h4>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                            <form name="frmImage">
                                <div>
                                    <label htmlFor={"imagesUpload"}>
                                        <MdFileUpload color="green"/>
                                    </label>
                                    <input type="file" id={"imagesUpload"} key={"imagesUpload"} multiple 
                                        name={"imagesUpload"} onChange={(e) => this.handleFile(e)}/>
                                </div>
                                <button className="myButton" type="button" 
                                    onClick={(e) => this.handleUpload(e)}>
                                    <FaUpload color={ICON_COLOR}/>&nbsp;
                                    {couterpart.translate('button_upload')}
                                </button>
                            </form>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <label>{ this.state.selectedFilenames }</label>
                        </div>
                    </div>
                    <div className="row" style={{ width: "100%"}}>
                        <div className="col-12">
                            <DesignImageList key={this.state.count }/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <ToastsContainer store={ToastsStore} position="bottom_center" />
                        </div>
                    </div>
                </div>
            );
        }else{
            return(<div>&nbsp;</div>);
        }
    }
}

export default ImageUploader;